import { ImageButton, Loading } from '../../UI';
import { Input } from '../../form';
import { CreateAssetCategoryFormProps } from './types';
import { useQuery } from '@apollo/client';
import { CategoryIcons } from '../../NewStrategy/types';
import { LIST_STRATEGY_ASSET_CATEGORY_ICONS } from '../../../http/apollo-queries';
import { useTranslation } from 'react-i18next';

export const CreateStrategyAssetCategoryForm = ({
  formik,
  strategyAssetCategories,
}: CreateAssetCategoryFormProps) => {
  const { t } = useTranslation();

  const {
    data: {
      listStrategyAssetCategoryIcons: {
        items: strategyAssetCategoryIcons = [],
      } = {},
    } = {},
    loading,
  } = useQuery<{ listStrategyAssetCategoryIcons: { items: CategoryIcons[] } }>(
    LIST_STRATEGY_ASSET_CATEGORY_ICONS
  );

  const handleClick = (iconId: string) => {
    formik.setValues({
      ...formik.values,
      iconId,
    });
  };

  return (
    <>
      {loading ? (
        <div className="flex h-full w-full">
          <Loading className="m-auto" status />
        </div>
      ) : (
        <>
          <div className="flex w-full px-20">
            <Input
              key="categoryName"
              size="full"
              name="categoryName"
              id="categoryName"
              formik={formik}
              type="text"
              placeholder={t('strategies.strategyAssetCategory.categoryName')}
              label={t('strategies.strategyAssetCategory.categoryName')}
              validate={(value: string) =>
                value.length === 0 ||
                strategyAssetCategories.some(
                  ({ title }) =>
                    title.toLocaleLowerCase() ===
                    formik.values.categoryName?.toLocaleLowerCase()
                )
              }
            />
          </div>
          <div className="flex flex-col items-center w-full h-full mt-16">
            <span className="font-medium">
              {t('strategies.strategyAssetCategory.chooseAnIcon')}
            </span>
            <div className="flex flex-wrap w-72 gap-3 ml-5 mt-7">
              {strategyAssetCategoryIcons.map(({ id, size: { original } }) => (
                <ImageButton
                  key={id}
                  imageSrc={original}
                  isSelected={id === formik.values.iconId}
                  onClick={() => handleClick(id)}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
};
